import React, { useCallback, useState, useMemo } from "react";
import { idExtractor, useMakeListAndDetail, useMakeListBuilder } from "../core/useMakeLayout";
import { ListEntry } from "./ListEntry";
import { EventFromRoute } from "./EventFromRoute";
import { DateTime } from "luxon";
import { useMyProfile, useMergedListItems } from "@seabrookstudios/pitch2table";
import CircularProgress from "@mui/material/CircularProgress";
import Event from "@mui/icons-material/Event";
import { NoItemsFound } from "../publisher/NoItemsFound";
import IconButton from "@mui/material/IconButton";
import Person from "@mui/icons-material/Person";
import AllInclusive from "@mui/icons-material/AllInclusive";
import Stack from "@mui/material/Stack";
import { AddSessionDialog } from "../sessions/AddSessionDialog";

const NoEvents = () => (
  <NoItemsFound>
    <Event sx={{ fontSize: 64, color: "text.secondary", mb: 2 }} />
    <p>No events. You can link a game to an event through the game detail page.</p>
  </NoItemsFound>
);

/**
 * @type {Filter<import("@seabrookstudios/pitch2table-core").Convention>[]}
 */
const ListFilters = [
  {
    /**
     * @param {import("@seabrookstudios/pitch2table-core").Convention} convention
     */
    filter: (convention) => !!(convention.startDate && convention.startDate <= DateTime.now().endOf("year").toMillis()),
    label: "THIS YEAR",
    count: 0,
    weight: 100,
  },
  {
    filter: (convention) => !!convention,
    label: "ALL",
    count: 0,
    weight: 0,
  },
];

export const ListAndDetail = () => {
  const [showAllEvents, setShowAllEvents] = useState(false);
  const { data: profile } = useMyProfile();

  const useWrappedQuery = () => useMergedListItems(showAllEvents);

  const title = useMemo(() => (showAllEvents ? "All Upcoming Events" : "My Upcoming Events"), [showAllEvents]);

  const Icon = useMemo(() => (showAllEvents ? AllInclusive : Person), [showAllEvents]);

  const Action = useCallback(
    () => (
      <Stack direction="row">
        <IconButton onClick={() => setShowAllEvents(!showAllEvents)}>
          <Icon />
        </IconButton>
        <AddSessionDialog />
      </Stack>
    ),
    [showAllEvents]
  );

  const useMakeList = useMakeListBuilder(ListEntry, idExtractor, title, NoEvents, Action);
  const ListAndDetail = useMakeListAndDetail(useWrappedQuery, ListFilters, "events", useMakeList, EventFromRoute);

  if (!profile) {
    return <CircularProgress />;
  }

  return <ListAndDetail />;
};
